import React from "react";
import { Box, Link, Paper, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import ProductCatalogVisibilityBadges from "./ProductCatalogVisibilityBadges";

const formatEur = (n) => {
  if (n == null || Number.isNaN(Number(n))) return "--";
  return `${Number(n).toFixed(2)}€`;
};

const DettaglioProdotto = ({
  product,
  onBack,
  totalClicks,
  clicksLoading,
  onOpenClicksDialog,
}) => {
  if (!product) return null;

  const showClickValue =
    clicksLoading || totalClicks == null ? (clicksLoading ? "..." : "—") : String(totalClicks);

  const canOpenClicks =
    typeof onOpenClicksDialog === "function" && !clicksLoading && totalClicks != null;

  return (
    <Box sx={{ mt: 3 }}>
      <Link
        component="button"
        type="button"
        underline="none"
        onClick={onBack}
        sx={{
          fontFamily: "Rubik",
          fontWeight: "bold",
          marginBottom: 2,
          color: "#0b3d87",
          cursor: "pointer",
          border: "none",
          background: "none",
          fontSize: 15,
          p: 0,
          transition: "font-weight 0.15s, color 0.15s",
          "&:hover": {
            fontWeight: 900,
            color: "#e00036"
          }
        }}
      >
        ⮜ Torna a prodotti
      </Link>
      <Grid2 container spacing={3}>
        <Grid2 xs={12} md={5}>
          <Paper
            sx={{
              p: 3,
              borderRadius: "14px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
                overflowX: "auto",
                pb: 1,
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": { height: 8 },
                "&::-webkit-scrollbar-thumb": { bgcolor: "#e0e0e0", borderRadius: 4 },
              }}
            >
              {(() => {
                const images = [product.linkImmagine, product.linkImmagine1, product.linkImmagine2].filter(
                  (img, idx, arr) => img && arr.indexOf(img) === idx
                );
                if (images.length === 0) {
                  return (
                    <Box
                      component="img"
                      src="https://placehold.co/450x300?text=Nessuna%5CnImmagine&font=rubik"
                      alt={`${product.nome} nessuna immagine disponibile`}
                      sx={{
                        width: 240,
                        height: 170,
                        borderRadius: "10px",
                        objectFit: "cover",
                        flexShrink: 0,
                        background: "#f5f5f5",
                      }}
                    />
                  );
                }
                return images.map((img, i) => (
                  <Box
                    key={i}
                    component="img"
                    src={img}
                    alt={`${product.nome} immagine ${i + 1}`}
                    sx={{
                      width: 240,
                      height: 170,
                      borderRadius: "10px",
                      objectFit: "cover",
                      flexShrink: 0,
                      background: "#f5f5f5",
                    }}
                  />
                ));
              })()}
            </Box>
          </Paper>
        </Grid2>
        <Grid2 xs={12} md={7}>
          <Paper
            sx={{
              p: 3,
              borderRadius: "14px",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: "Rubik",
                fontWeight: "bold",
                color: "#0b3d87",
                mb: 1,
              }}
            >
              {product.nome}
            </Typography>
            <ProductCatalogVisibilityBadges product={product} sx={{ mb: 1.5, alignItems: "flex-start" }} />
            <Typography
              sx={{
                fontFamily: "Rubik",
                color: "#808080",
                mb: 2,
              }}
            >
              {product.descrizione || product.caratteristicheTecniche || "Nessuna descrizione disponibile."}
            </Typography>
            <Grid2 container spacing={2}>
              <Grid2 xs={6}>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    color: "#808080",
                    fontSize: 13,
                  }}
                >
                  Prezzo
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: "#0b3d87",
                    fontSize: 20,
                  }}
                >
                  {formatEur(product.prezzoVendita)}
                </Typography>
              </Grid2>
              <Grid2 xs={6}>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    color: "#808080",
                    fontSize: 13,
                  }}
                >
                  Spese di spedizione
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: "#0b3d87",
                    fontSize: 20,
                  }}
                >
                  {formatEur(product.speseDiSpedizione)}
                </Typography>
              </Grid2>
              <Grid2 xs={6}>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    color: "#808080",
                    fontSize: 13,
                  }}
                >
                  Click totali
                </Typography>
                <Typography
                  onClick={canOpenClicks ? onOpenClicksDialog : undefined}
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: "#0b3d87",
                    fontSize: 20,
                    cursor: canOpenClicks ? "pointer" : "default",
                    textDecoration: canOpenClicks ? "underline" : "none",
                  }}
                >
                  {showClickValue}
                </Typography>
              </Grid2>
              <Grid2 xs={6}>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    color: "#808080",
                    fontSize: 13,
                  }}
                >
                  Disponibilità
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: product.disponibilita > 0 ? "#2e7d32" : "#e00036",
                    fontSize: 16,
                  }}
                >
                  {product.disponibilita > 0 ? `${product.disponibilita}` : "Non disponibile"}
                </Typography>
              </Grid2>
              {/* <Grid2 xs={6}>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    color: "#808080",
                    fontSize: 13,
                  }}
                >
                  Categoria
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: "#0b3d87",
                    fontSize: 16,
                  }}
                >
                  {product.alberoCategorie || "N/D"}
                </Typography>
              </Grid2> */}
            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default DettaglioProdotto;
